import React, { useEffect, useState } from 'react';
import { ActivityIndicator, Alert, Linking, ScrollView, View, TouchableOpacity } from 'react-native';
import { Text } from 'react-native';

import { useNavigation } from '@react-navigation/native';
import SearchHeader from '../../components/SearchHeader/SearchHeader';
import Toast from '../../components/Toast/Toast';
import ProfileService from '../../services/ProfileService/ProfileService';
import BusinessData from './components/BusinessData/BusinessData';
import ChangePasswordDrop from './components/ChangePasswordDrop/ChangePasswordDrop';
import DropDownProfile from './components/DropDownProfile/DropDownProfile';
import General from './components/General/General';
import Switch from './components/Notifications/Switch/Switch';
import { styles } from './styles';
import ButtonComponent from '../../components/ButtonComponent/ButtonComponent';
import { set } from 'zod';
import { Colors } from '../../constants/Colors';
import { OneSignal } from 'react-native-onesignal';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useAuthStore } from '../../store/AuthStore';
import { useUserStore } from '../../store/UserStore';
import ModalDesactive from './components/ModalDesactive/ModalDesactive';
import AuthService from '../../services/AuthService/AuthService';
import {useBagStore} from '../../store/BagStore';
import {useCatalogStore} from '../../store/CatalogStore';
import {useFilterStore} from '../../store/FilterStore';
import useExtendedTermsStore from '../../store/ExtendedTermsStore';
import { showSuccess } from '../../utils/globalAlert';
import {useBiometricStore} from '../../store/BiometricStore';
import {
  BiometryType,
  clearBiometricCredentials,
  getBiometryLabel,
  getSupportedBiometry,
  saveCredentialsBiometric,
} from '../../utils/biometricAuth';


interface ISwitch {
  acceptMail?: boolean;
  acceptMessages?: boolean;
}

const Profile = () => {
  const { goBack } = useNavigation();

  const [activeModal, setActiveModal] = useState<string>('');
  const [clientData, setClientData] = useState<IRootClientData>();
  const [toast, setToast] = useState<boolean>(false);
  const [loadingUpdate, setLoadingUpdate] = useState<boolean>(false);
  const [preference, setPreference] = useState<ISwitch>({
    acceptMail: false,
    acceptMessages: false,
  });
  const [desativarConta, setDesativarConta] = useState<boolean>(false);

  const openToast = () => {
    setToast(true);
    const timeout = setTimeout(() => {
      setToast(false);
    }, 5000);
    return () => clearTimeout(timeout);
  };

  const toggleDesativarConta = () => {
    setDesativarConta(!desativarConta);
  };

  const toggleDrop = (modal: string) => {

    if (modal !== activeModal) {
      setActiveModal(modal);
    } else {
      setActiveModal('');
    }
  };



  const getGeneralInfo = async () => {
    try {
      const response = await ProfileService.GetGeneralClientInfo();
      setClientData(response);
    } catch (error) {
      console.error(error);
    }
  };

  const [notificationData, setNotificationData] = useState<IAccepted>();
  const [loadingNotification, setLoadingNotification] = useState<boolean>(false);
  const [notificationDataChanged, setNotificationDataChanged] = useState<boolean>(false);

  const getNotificationInfo = async () => {
    try {
      setLoadingNotification(true);
      const response = await ProfileService.GetNotificationInfo();
      setNotificationData(response);
    } catch (error) {
      console.error(error);
    }
    setLoadingNotification(false);

  }

  const [commercialData, setCommercialData] = useState<IRootCommercialData>();
  const [loadingCommercial, setLoadingCommercial] = useState<boolean>(false);

  const getCommercialInfo = async () => {
    try {
      setLoadingCommercial(true);
      const response = await ProfileService.GetCommertialInfo();
      setCommercialData(response);
    } catch (error) {
      console.error(error);
    }
    setLoadingCommercial(false);
  }


  const UpdatePreferences = async (mail?: boolean, messages?: boolean) => {
    try {
      setLoadingUpdate(true);
      await ProfileService.updateNotificationsPreference({
        acceptMessages: messages,
        acceptMail: mail,
      });
      setNotificationData({ acceptMail: mail, acceptMessages: messages });
      showSuccess('Sucesso', 'Preferências atualizadas com sucesso');
    } catch (error) {
      Alert.alert(
        'Erro',
        String(error?.response?.details) || 'Erro ao atualizar preferências',
      );
    } finally {
      setLoadingUpdate(false);
    }
  };

  useEffect(() => {
    getGeneralInfo();
    getNotificationInfo();
    getCommercialInfo();
  }, []);



  const [oneSignalSubscriptions, setOneSignalSubscriptions] = useState<{ clientCode: string; playerId: string }[]>([]);
  const {user, setToken} = useAuthStore();
  const {setTemporaryPasswordLogin} = useUserStore();
  const {biometricEnabled, setBiometricEnabled} = useBiometricStore();
  const [biometryType, setBiometryType] = useState<BiometryType>(null);
  const [openBiometricModal, setOpenBiometricModal] = useState<boolean>(false);
  const biometryLabel = getBiometryLabel(biometryType);

  useEffect(() => {
    (async () => {
      setBiometryType(await getSupportedBiometry());
    })();
  }, []);

  const handleToggleBiometric = () => {
    if (biometricEnabled) {
      // Desligar: remove credenciais protegidas e desabilita.
      clearBiometricCredentials();
      setBiometricEnabled(false);
    } else {
      // Ligar: precisa confirmar a senha para regravar as credenciais protegidas.
      setOpenBiometricModal(true);
    }
  };

  const handleEnableBiometric = async (password: string) => {
    setOpenBiometricModal(false);
    const loginUsername = (user as any)?.user || (user as any)?.email;
    if (!loginUsername || !password) {
      Alert.alert('Conecta Brasal', 'Informe sua senha para ativar a biometria.');
      return;
    }
    try {
      // Valida a senha antes de salvar, para não gravar credenciais incorretas.
      await AuthService.loginService(loginUsername, password);
      await saveCredentialsBiometric(loginUsername, password);
      setBiometricEnabled(true);
      Alert.alert('Sucesso', `Login por ${biometryLabel} ativado com sucesso.`);
    } catch (error) {
      Alert.alert('Conecta Brasal', 'Senha incorreta. Não foi possível ativar a biometria.');
    }
  };
  const {clearCart} = useBagStore();
  const {clearCatalog} = useCatalogStore();
  const {clearFilters} = useFilterStore();
  const {clearData: clearExtendedTerms} = useExtendedTermsStore();
  const handleNotificationPermission = async () => {
    const playerId = await OneSignal.User.pushSubscription.getIdAsync();
    const clientId = user?.current_client?.id;
    const clientCode = user?.current_client?.clientCode;
    if (clientId && playerId) {
      await ProfileService.createOneSignalSubscription(playerId, clientCode);
    }
  };

  const [openModalDesactive, setOpenModalDesactive] = useState<boolean>(false);
  const [loadingDesactive, setLoadingDesactive] = useState<boolean>(false);

  const onDesactive = async (password: string) => {
      setLoadingDesactive(true);
      setOpenModalDesactive(false);
      await ProfileService.desactivateAccount(password).then((response) => {
          if(response) {
           showSuccess('Sucesso', 'Conta desativada com sucesso... Em breve você será deslogado.');
           setTimeout(() => {
             handleLogOff();
           }, 3000);
          }
        setLoadingDesactive(false);
      }).catch((error) => {
          console.error(error);
          Alert.alert('Erro', 'Houve um problema ao desativar a conta... Por favor, tente mais tarde.');
        setLoadingDesactive(false);
      });

  };

  const handleLogOff = async () => {
      try {
        await AuthService.logoutPost();
        setToken('');
        defUser(null);
        clearCart();
        clearFilters();
        clearExtendedTerms();
        clearCatalog();
        setTemporaryPasswordLogin(false);
      } catch (error) {
        console.error(error);
      } finally {
        setToken('');
        defUser(null);
        clearCart();
        clearFilters();
        clearExtendedTerms();
        clearCatalog();
        setTemporaryPasswordLogin(false);
      }
    };

  return (
    <>
      {toast && <Toast title="Senha alterada com sucesso!" />}
      <ScrollView style={styles.scrollView}>
        <View style={styles.spaceXY}>
          <View style={styles.spaceHeader}>
            <SearchHeader onPress={goBack} title="Configuração de conta" />
          </View>
          <DropDownProfile
            onPress={() => toggleDrop('Geral')}
            title="Geral"
            activeComponent={'Geral' === activeModal}
          />
          <DropDownProfile
            onPress={() => toggleDrop('Alterar Senha')}
            title="Alterar Senha"
            activeComponent={'Alterar Senha' === activeModal}
          />
          <DropDownProfile
            onPress={() => toggleDrop('Equipe comercial')}
            title="Equipe comercial"
            activeComponent={'Equipe comercial' === activeModal}
          />
          <DropDownProfile
            onPress={() => toggleDrop('Notificação')}
            title="Notificação"
            activeComponent={'Notificação' === activeModal}
          />
          {biometryType && (
            <DropDownProfile
              onPress={() => toggleDrop('Biometria')}
              title="Login por biometria"
              activeComponent={'Biometria' === activeModal}
            />
          )}
          {activeModal === 'Geral' && (
            <General clientData={clientData} />
          )}
          {activeModal === 'Alterar Senha' && (
            <ChangePasswordDrop onSave={() => openToast()} />
          )}
          {activeModal === 'Equipe comercial' && (
            loadingCommercial ?
              (
                <View style={styles.container}>
                  <ActivityIndicator color={Colors.RedPallete.red} size={20} />
                </View>
              )
              :
              <BusinessData onSave={() => null} data={commercialData} />
          )}
          {activeModal === 'Notificação' && (
            loadingNotification ?
              (
                <View style={styles.container}>
                  <ActivityIndicator color={Colors.RedPallete.red} size={20} />
                </View>
              )
              : (<View style={styles.container}>
                <Text style={styles.title}>Configurar Notificações</Text>
                <View style={styles.containerInput}>
                  <Text style={styles.acept}>Aceites</Text>
                  <Switch
                    title="Notícias e Anúncios por e-mail"
                    onPress={() => {
                      if (notificationData) {
                        setNotificationData({
                          ...notificationData,
                          acceptMail: !notificationData.acceptMail,
                        });
                      }
                    }}
                    initialState={notificationData?.acceptMail}
                  />
                  <Switch
                    title="Notificações e mensagens promocionais"
                    onPress={() => {
                      if (notificationData) {
                        if (!notificationData.acceptMessages) {
                          handleNotificationPermission();
                        }
                        setNotificationData({
                          ...notificationData,
                          acceptMessages: !notificationData.acceptMessages,
                        });
                      }
                    }}
                    initialState={notificationData?.acceptMessages}
                  />
                </View>
                <View style={styles.buttonContainer}>
                  <ButtonComponent
                    title="Salvar Preferências"
                    style={{ width: '100%' }}
                    onPress={() => {
                      UpdatePreferences(
                        notificationData.acceptMail,
                        notificationData.acceptMessages,
                      );
                    }}
                  />
                </View>
              </View>)
          )}
          {activeModal === 'Biometria' && biometryType && (
            <View style={styles.container}>
              <Text style={styles.title}>Login por {biometryLabel}</Text>
              <View style={styles.containerInput}>
                <Switch
                  title={`Entrar com ${biometryLabel}`}
                  onPress={handleToggleBiometric}
                  initialState={biometricEnabled}
                />
              </View>
            </View>
          )}
          <Text style={styles.quest}>Você ainda tem uma pergunta?</Text>
          <Text style={styles.contact}>
            Seu você não encontrou a sua pergunta, entre em contato com o nosso
            0800!
          </Text>
          <Text
            style={styles.phone}
            onPress={() => Linking.openURL('tel:08000615000')}>
            0800 061 5000
          </Text>
          <Text style={styles.service}>
            Serviço de Atendimento ao Revendedor
          </Text>
          {activeModal === 'Geral' && (
                 <View style={styles.desativarConta}>
                     <TouchableOpacity onPress={toggleDesativarConta}>
                       <Text style={styles.quest}>Desativar conta {desativarConta ? '↑' : '↓'}</Text>
                     </TouchableOpacity>
                 </View>
                    )}
         {activeModal === 'Geral' && desativarConta &&
             <View style={styles.container}>
                      <Text style={styles.atention}>1. Todos os dados do usuário serão apagados do banco de dados;</Text>
                      <Text style={styles.atention}>2. A conta será deslogada imediatamente após a desativação.</Text>
                      <View style={styles.buttonContainer}>
                        <ButtonComponent
                          title="Desativar"
                          disabled={loadingDesactive}
                          style={{ width: '100%' }}
                          onPress={() => {
                            setOpenModalDesactive(true)
                          }}
                        />
                    </View>
            </View>
             }
        </View>
        <ModalDesactive
          visible={openModalDesactive}
          onRequestClose={() => setOpenModalDesactive(false)}
          onDesactive={(password) => onDesactive(password)}
         />
        <ModalDesactive
          visible={openBiometricModal}
          onRequestClose={() => setOpenBiometricModal(false)}
          onDesactive={(password) => handleEnableBiometric(password)}
          title="Ativar biometria"
          message={`Para ativar o login por ${biometryLabel}, digite sua senha.`}
          confirmLabel="Ativar"
          cancelLabel="Cancelar"
         />
      </ScrollView>
    </>
  );
};

export default Profile;
